var render = function render(){var _vm=this,_c=_vm._self._c;return _c('simple-button',{attrs:{"mapgl":_vm.mapgl,"module":_vm.module,"layer-id":_vm.id,"icon":_vm.icon,"title":_vm.title,"add-handler":_vm.addHandler,"layers-ids":_vm.layersIds}})
}
var staticRenderFns = []

export { render, staticRenderFns }